import { render, staticRenderFns } from "./DisplayOrderItems.vue?vue&type=template&id=0dbe6142&scoped=true&"
import script from "./DisplayOrderItems.vue?vue&type=script&lang=js&"
export * from "./DisplayOrderItems.vue?vue&type=script&lang=js&"
import style0 from "./DisplayOrderItems.vue?vue&type=style&index=0&id=0dbe6142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbe6142",
  null
  
)

export default component.exports